import state from './state';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export const household = {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
